import { UserAuditLogEntry } from 'apis/auditLogs';

import { LineItems } from './lineItems';
import { SummaryItems } from './summaryItems';
import { UserActivityCard } from './userActivityCard';
import { statusColors } from './userActivityTypes.utils';

type ReturnReceivedProps = {
  entry: UserAuditLogEntry<'COMMERCE_RETURN_RECEIVED'>;
};

export const ReturnReceived = ({ entry }: ReturnReceivedProps): JSX.Element => (
  <UserActivityCard
    entry={entry}
    icon="undo"
    color={statusColors.warning}
    title="Return received"
    summary={
      <SummaryItems
        items={[
          {
            key: 'order',
            content: entry.order_id,
            copyText: entry.order_id,
            label: 'Order ID',
          },
          {
            key: 'return',
            content: entry.return_id,
            copyText: entry.return_id,
            label: 'Return ID',
          },
        ]}
      />
    }
  >
    {entry.line_items?.length ? <LineItems items={entry.line_items} /> : null}
  </UserActivityCard>
);
